/* eslint-disable */
import jwtDecode from "jwt-decode";
import { ApiCalls } from "../api-calls";
import OktaAuthRef from "../auth/okta";

const UserHelper = {
  // New methods start here
  checkIfHasPosAdminAccess: () => {
    const idToken = OktaAuthRef.getIdToken();
    const decoded = jwtDecode(idToken);
    let hasAdminAccess = false;
    if (decoded && decoded.securityRoles && decoded.securityRoles.length) {
      if (decoded.securityRoles.indexOf("5") > -1) {
        //  if (decoded.securityRoles.indexOf('51') > -1) {
        hasAdminAccess = true;
      }
    }
    return hasAdminAccess;
  },
  checkIfHasPracticeAdminAccess: () => {
    const idToken = OktaAuthRef.getIdToken();
    const decoded = jwtDecode(idToken);
    let hasAdminAccess = false;
    if (decoded && decoded.securityRoles && decoded.securityRoles.length) {
      if (decoded.securityRoles.indexOf("10") > -1) {
        //  if (decoded.securityRoles.indexOf('5') > -1) {
        hasAdminAccess = true;
      }
    }
    return hasAdminAccess;
  },
  checkIfHasPracticeUserAccess: () => {
    const idToken = OktaAuthRef.getIdToken();
    const decoded = jwtDecode(idToken);
    let hasAdminAccess = false;
    if (decoded && decoded.securityRoles && decoded.securityRoles.length) {
      if (decoded.securityRoles.indexOf("11") > -1) {
        hasAdminAccess = true;
      }
    }
    return hasAdminAccess;
  },
  setUserInfo: userinfo => {
    localStorage.setItem("userinfo", JSON.stringify(userinfo));
  },
  getActiveClinic: () => {
    const activeClinic = {
      PracticeID: null
    };
    const idToken = OktaAuthRef.getIdToken();
    // console.log('idToken :>> ', idToken);
    const decoded = jwtDecode(idToken);
    if (decoded && decoded.assignedPractices && decoded.assignedPractices.length) {
      //decoded.assignedPractices.forEach(item => {

      //});
      activeClinic.PracticeID = decoded.assignedPractices[0];
    }
    return activeClinic;
  },
  // New methods end here
  // Old methods start here
  setActiveClinic: clinic => {
    const stringyfiedUserInfo = localStorage.getItem("userinfo");
    if (stringyfiedUserInfo && stringyfiedUserInfo.length) {
      const userInfo = JSON.parse(stringyfiedUserInfo);
      const selectedClinic = userInfo.find(
        c => `${c.PracticeID}+${c.SecurityRole}` === `${clinic.PracticeID}+${clinic.SecurityRole}`
      );
      if (selectedClinic) {
        localStorage.setItem("active-clinic", JSON.stringify(selectedClinic));
        return selectedClinic;
      }
    }
  },
  getUserInfo: () => {
    let userInfo = null;
    const stringyfiedUserInfo = localStorage.getItem("userinfo");
    if (stringyfiedUserInfo && stringyfiedUserInfo.length) {
      userInfo = JSON.parse(stringyfiedUserInfo);
    }
    return userInfo;
  },
  hasAdminAccess: () => {
    let activeClinic = null;
    const stringyfiedActiveClinic = localStorage.getItem("active-clinic");
    if (stringyfiedActiveClinic && stringyfiedActiveClinic.length) {
      activeClinic = JSON.parse(stringyfiedActiveClinic);
    }
    if (activeClinic && activeClinic.SecurityRole === "BillPayAdmin") {
      return true;
    }
  },
  hasPOSAdminAccess: () => {
    let activeClinic = null;
    const stringyfiedActiveClinic = localStorage.getItem("active-clinic");
    if (stringyfiedActiveClinic && stringyfiedActiveClinic.length) {
      activeClinic = JSON.parse(stringyfiedActiveClinic);
    }
    if (activeClinic && activeClinic.SecurityRole === "POSAdmin") {
      return true;
    }
  },
  clearUserInfo: () => {
    localStorage.clear();
  },
  syncUserInfo: async () => {
    const { data } = await ApiCalls.fetchUserName();
    // console.log('data :>> ', data);
    if (data && data.length) {
      UserHelper.setUserInfo({
        Username: data
      })
    }
  }
  // Old methods end here
};

export default UserHelper;
